<template>
  <ul class="site-social" :class="classes">
    <template v-for="account in socialAccountsSorted">
      <li :key="account._id.$oid" v-if="account.url">
        <SocialAccount
          :account="account"
          :campsite="campsite"
          :isFreePlan="isFreePlan"
        />
      </li>
    </template>
  </ul>
</template>

<script>
import SocialAccount from './social-account';

export default {
  components: {
    SocialAccount,
  },

  props: {
    isTop: Boolean,
    socialAccounts: Array,
    campsite: Object,
    isFreePlan: Boolean,
  },

  computed: {
    socialAccountsSorted() {
      return [...this.socialAccounts].sort((a, b) => a.position - b.position);
    },

    classes() {
      return {
        'site-social--top': this.isTop,
      };
    },
  },
};
</script>

<style lang="scss">
.site-social {
  --icon-padding: 0.425rem;

  align-items: center;
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  justify-content: center;
  position: relative;
  margin: 1.25rem 0 0;
  padding: 0;
  column-gap: 0.75rem;
  row-gap: 0.425rem;

  .site__header--align-left & {
    justify-content: flex-start;
    margin-left: calc(-1 * var(--icon-padding));
    margin-bottom: 0;
    margin-top: 0.5rem;
    column-gap: 0.425rem;
    row-gap: 0.125rem;
  }

  &--top {
    margin-bottom: -0.325rem;
    margin-top: 0.75rem;
  }
}

.site-social a {
  color: var(--p-social-color);
  display: inline-flex;
  font-size: 1.925rem;
  padding: var(--icon-padding);
  vertical-align: top;
  transition: transform var(--g-transition-speed) cubic-bezier(0.4, 0, 0.2, 1);

  .site__header--align-left & {
    font-size: 1.5rem;
  }

  &:hover,
  &:focus {
    color: var(--p-social-color);
    transform: scale(1.1);
  }

  .v-svg-icon {
    flex-shrink: 0;
  }
}
</style>
